import {atom} from "jotai";
import {TIME_FORMAT_HOURS} from "../../constants";

export const timeFormatAtom = atom(TIME_FORMAT_HOURS);